import React from "react";
import Navbar from "../../../../Home/components/Navbar";
import TPSSvg from "../../../../utils-component/tpsSvg";
import hero from "../../../../../assets/images/service_it-support.jpg"

type Props = {};

const ItHero = (props: Props) => {
  return (
    <section
      id="hero"
      className="bg-black bg-opacity-70"
      style={{ backgroundImage: `url(${hero})` }}
    >
      <Navbar />
      <div className="bg-black py-14 lg:py-10 bg-opacity-70 max-h-screen overflow-hidden">
        <div className="flex md:flex-row">
          <div className="text-left px-6 md:p-12 md:pt-8 lg:p-14 lg:py-6 w-full md:w-1/2">
            <p className="text-primary100 font-semibold text-lg">Services</p>
            <h1 className="text-white text-3xl md:text-[2.75rem] font-semibold md:font-bold text-left my-6 md:my-8 md:leading-tight">
              Specialist IT Support and Consultancy Services from TPS
            </h1>
            <p className="text-white text-semibold text-left mb-10 text-xl">
              Trust your IT needs with passionate experts in delivering IT
              Support excellence.
            </p>
          </div>
          {/* svg/logo */}
          <div className="hidden md:block w-full md:w-1/2">
            <TPSSvg />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ItHero;
